import { useEffect } from 'react';
import { useAppDispatch } from './useAppDispatch';
import { fetchCountries } from '../../slices/countries/countriesSlice';
import { ROUTES } from '../constants/routes';

export const useCountriesInfo = () => {
  const locationExceptions = [
    ROUTES.SIGN_UP,
    ROUTES.EMAIL_SENT,
    ROUTES.PROCESS_SUCCESS,
    ROUTES.CONFIRMATION,
    ROUTES.LOGIN,
    ROUTES.ACCEPTED_INVITE,
    ROUTES.JOIN_COMPANY,
    ROUTES.PASSWORD_RESET,
    ROUTES.DEMO_LOGIN,
    ROUTES.DEMO_SIGNUP,
  ];
  const dispatch = useAppDispatch();
  const locationIncludeExceptionUrl = locationExceptions.some((el) => {
    return location.pathname.includes(el);
  });
  const token = localStorage.getItem('access_token');
  useEffect(() => {
    if (!locationIncludeExceptionUrl && token) {
      dispatch(fetchCountries());
    }
  }, [locationIncludeExceptionUrl, token]);
};
